module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_03_6NV26_1SA_GB8.1b06bafc.png";